import React, { Component } from "react";
import LeftSideNavigation from "../../../../vendorDashboardComponents/navigationSection/LeftSideNavigation";
import HomeReusableTopBarNavigation from "../../../superAdminReusable/superAdminHomeButton/HomeReusableTopBarNavigation";
import { TopTextReusableComponent } from "../../../../vendorOnboradingComponents/reusableOnboardingComponent/TopTextReusable/TopTextReusableComponent";
import Form from "react-bootstrap/Form";
import {
  ReusableOnboardingLink,
  ReusableOnboardingButton,
  ReusableOnboardingMapButton,
} from "../../../../vendorOnboradingComponents/reusableOnboardingComponent/ButtonReusable/ReusableOnboardingButton";
import SuggestNewButton from "../../../../vendorOnboradingComponents/reusableOnboardingPopupComponent/suggestNew/SuggestNewButton";
import isEmpty from "../../../../../store/validation/is-Empty";

import PropTypes from "prop-types";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { clear_all_errors } from "../../../../../store/actions/errorActions";
import { superadmin_create_and_update_restaurant } from "../../../../../store/actions/SuperAdminActions/adminNewVendorOnboard";
import { AmealioLoader } from "../../../../Loader/AmealioLoader";

export class SuperAdminVendorOtherFeatures extends Component {
  constructor(props) {
    super(props);
    this.state = {
      vendor_id: "",
      actionButton: false,
      selectedTab: 2,
      all_other_features: [],
      selected_other_features: [],
      primary_other_features: {},
    };
  }

  componentDidMount() {
    let onboarding = this.props?.editDataAction
      ? this.props?.editData
      : this.props?.onboardingData;
    let adminVendorId = this.props?.editDataAction
      ? this.props?.editData?.vendor_id
      : JSON.parse(localStorage.getItem("vendorId"));
    const formData = {
      vendor_id: adminVendorId,
    };
    if (adminVendorId !== null || adminVendorId !== undefined) {
      this.props.superadmin_create_and_update_restaurant(formData);
      this.setState({
        vendor_id: formData.vendor_id,
      });
    }
    if (this.props.auth.loader) {
      this.setState({
        loader: true,
      });
    }
  }

  static getDerivedStateFromProps(nextProps, nextState) {
    let onboarding = nextProps?.editDataAction
      ? nextProps?.editData
      : nextProps?.onboardingData;
    if (
      !isEmpty(onboarding?._id) &&
      !isEmpty(nextProps.other_features) &&
      !nextState.hasSetMapProps
    ) {
      let selected_other_features = onboarding?.selected_other_features;
      let primary_other_features = onboarding?.primary_other_features;
      if (
        !isEmpty(onboarding?.primary_other_features) &&
        !isEmpty(selected_other_features[0])
      ) {
        if (
          onboarding?.primary_other_features !== "" &&
          isEmpty(selected_other_features[0]._id) &&
          selected_other_features.length > 0 &&
          isEmpty(primary_other_features._id)
        ) {
          selected_other_features = nextProps.other_features.filter(
            (featuress) => selected_other_features.includes(featuress._id)
          );
          primary_other_features = nextProps.other_features.filter(
            (featuress) => featuress._id === primary_other_features
          )[0];
        }
      }
      let all_other_features = nextProps.other_features.filter(
        (other_feature) =>
          !selected_other_features.some(
            (selected) => selected._id === other_feature._id
          ) && other_feature.status !== "NOTAPPROVED"
      );
      return {
        all_other_features: all_other_features,
        selected_other_features: !isEmpty(selected_other_features)
          ? selected_other_features
          : [],
        primary_other_features: !isEmpty(primary_other_features)
          ? primary_other_features
          : {},
        hasSetMapProps: true,
      };
    }
    if (nextProps.auth.loader !== nextState.loader) {
      return {
        loader: nextProps.auth.loader,
      };
    }
    if (nextProps.errors !== nextState.errors) {
      return {
        errors: nextProps.errors,
      };
    }
    return null;
  }

  /****************************************
   * @DESC - Payment Method SELECTOR
   ****************************************/
  onRestaurantSelectorArraySelector = (icon, index) => (e) => {
    let buttonArray = this.state.all_other_features;
    buttonArray.splice(index, 1);
    let Restaurant = this.state.selected_other_features;
    let primaryIcon = this.state.primary_other_features;
    if (Restaurant.length === 0 || primaryIcon === {}) {
      Restaurant.push(icon);
      this.setState({
        selected_other_features: Restaurant,
        primary_other_features: icon,
        actionButton: true,
      });
    } else {
      let isAlreadyPresent = Restaurant.includes(icon);
      if (isAlreadyPresent) {
        let indexOf = Restaurant.indexOf(icon);
        if (indexOf === 0 || indexOf) {
          Restaurant.splice(indexOf, 1);
        }
      } else {
        Restaurant.push(icon);
      }
    }
    this.setState({
      selected_other_features: Restaurant,
      actionButton: true,
    });
  };

  onRestaurantsPrimarySelector = (icon) => (e) => {
    this.setState({
      primary_other_features: icon,
      actionButton: true,
    });
  };

  /****************************************
   * @DESC - Remove Primary button handler
   ****************************************/
  removeButton = (icon) => (e) => {
    let {
      all_other_features,
      selected_other_features,
      primary_other_features,
    } = this.state;

    let iconIndexAtAllIcons = all_other_features.findIndex(
      (icons) => icons._id === icon._id
    );
    let iconIndexAtSelectedIcons = selected_other_features.findIndex(
      (icons) => icons._id === icon._id
    );
    let iconAtPrimaryIcon =
      !isEmpty(primary_other_features) &&
      primary_other_features._id === icon._id
        ? true
        : false;
    if (selected_other_features.length === 0) {
      selected_other_features.push(icon);
      all_other_features.splice(iconIndexAtAllIcons, 1);
      primary_other_features = icon;
    } else if (iconAtPrimaryIcon) {
      selected_other_features.splice(iconIndexAtSelectedIcons, 1);
      all_other_features.push(icon);
      if (selected_other_features.length === 1) {
        primary_other_features = selected_other_features[0];
      } else {
        primary_other_features = {};
      }
    } else if (iconIndexAtSelectedIcons === 0 || iconIndexAtSelectedIcons) {
      selected_other_features.splice(iconIndexAtSelectedIcons, 1);
      all_other_features.push(icon);
      if (selected_other_features.length === 1) {
        primary_other_features = selected_other_features[0];
      }
    } else {
      selected_other_features.push(icon);
      all_other_features.splice(iconIndexAtAllIcons, 1);
    }

    this.setState({
      selected_other_features: selected_other_features,
      all_other_features: all_other_features,
      primary_other_features: primary_other_features,
      actionButton: true,
    });
  };

  onWithOutApiCall = (e) => {
    this.props.history.push({
      pathname: this.props?.editDataAction
        ? "/admin_edit_serviceoffered"
        : "/addvendorserviceoffered",
    });
  };

  onHandleSubmit = (e) => {
    e.preventDefault();
    let onboarding = this.props?.editDataAction
      ? this.props?.editData
      : this.props?.onboardingData;
    if (onboarding && onboarding?.selected_other_features.length > 0) {
      const formData = {
        vendor_id: this.state.vendor_id,
        id: onboarding?._id,
        selected_other_features: this.state.selected_other_features,
        primary_other_features: this.state.primary_other_features,
      };
      this.props.superadmin_create_and_update_restaurant(formData);
      this.props.history.push(
        this.props?.editDataAction
          ? "/admin_edit_serviceoffered"
          : "/addvendorserviceoffered"
      );
    } else {
      const formData = {
        vendor_id: this.state.vendor_id,
        id: onboarding?._id,
        selected_other_features: this.state.selected_other_features,
        primary_other_features: this.state.primary_other_features,
        page_completed_till: 12,
      };
      this.props.superadmin_create_and_update_restaurant(formData);
      this.props.history.push(
        this.props?.editDataAction
          ? "/admin_edit_serviceoffered"
          : "/addvendorserviceoffered"
      );
    }
  };

  renderDressCodeFields = () => {
    const { selected_other_features, primary_other_features, actionButton } =
      this.state;
    return (
      <React.Fragment>
        <div className="restaurant_type_onboarding_main">
          <div className="margin-bottom-chains-onboarding">
            <div className="cuisine-main ">
              <div className="col-12 located-inside-heading-text">
                <h3 className="text-dark">
                  What special features, events and activities do you provide?
                </h3>
                <p>(Select all the options you provide)</p>
              </div>
              <div
                className={
                  this.state.all_other_features.length > 8
                    ? "cuisine-main-padding-border"
                    : ""
                }
              >
                <div
                  id="box-style"
                  className="cuisine-main-padding"
                  style={{ display: "flex", flexWrap: "wrap" }}
                >
                  {this.state.all_other_features.map((icon, index) => (
                    <ReusableOnboardingMapButton
                      key={index}
                      classsection="onboarding_mapbutton_reusable onboarding_mapbutton_reusable_type"
                      src={icon.icon}
                      title={icon.title}
                      onClick={this.onRestaurantSelectorArraySelector(
                        icon,
                        index
                      )}
                    />
                  ))}
                </div>
              </div>
              <div className="suggest-button-heading">
                <SuggestNewButton categoryId={"5f562c9094ac7fdf47ea1d18"} />
              </div>

              {/** */}
              {!isEmpty(this.state.selected_other_features) ? (
                <React.Fragment>
                  <div className="f14-500 mt-4">
                    Out of the selections below, which one is primary?
                  </div>
                  <div className="f11-400 opacity5">
                    Select only one of the options below as a default - this is
                    shown to the user.
                  </div>
                </React.Fragment>
              ) : null}

              <div
                className="cuisine-main-padding-bottom mobile-device-bottom-margin mt-4 mb-md-4 mb-lg-4 mb-xl-4"
                style={{ display: "flex", flexWrap: "wrap" }}
              >
                {this.state.selected_other_features.map((icon, index) => (
                  <ReusableOnboardingMapButton
                    key={index}
                    classsection={
                      icon._id === this.state.primary_other_features._id
                        ? "onboarding_mapbutton_reusable onboarding_mapbutton_reusable_active_two onboarding_mapbutton_reusable_type"
                        : "onboarding_mapbutton_reusable onboarding_mapbutton_reusable_type onboarding_mapbutton_reusable_active"
                    }
                    src={icon.icon}
                    title={icon.title}
                    onClick={this.onRestaurantsPrimarySelector(icon)}
                    displayPrimary={
                      icon._id === this.state.primary_other_features._id
                        ? true
                        : false
                    }
                    displayRemove={true}
                    removeButtonClick={this.removeButton(icon)}
                  />
                ))}
              </div>
            </div>
          </div>
          <div className="onboarding-map-setup-screen-autodetect-button">
            {/* <div className="onboarding-map-setup-screen-autodetect-button-inside"> */}
            <ReusableOnboardingLink
              buttonTitle="Back Button"
              buttonClass="onboarding_button_link_reusable onboarding_button_link_reusable_white"
              buttonText="Back"
              link={
                this.props?.editDataAction
                  ? "/admin_edit_accessiblity"
                  : "/addvendoraccessiblity"
              }
            />
            <ReusableOnboardingButton
              buttonTitle="Next Button"
              buttonClass={
                selected_other_features.length <= 0 ||
                isEmpty(primary_other_features._id)
                  ? "onboarding_button_link_reusable onboarding_button_link_reusable_gray ml-3"
                  : "onboarding_button_link_reusable onboarding_button_link_reusable_red ml-3"
              }
              disabled={
                selected_other_features.length <= 0 ||
                isEmpty(primary_other_features._id)
                  ? true
                  : false
              }
              buttonText="Next"
              onClick={actionButton === false ? this.onWithOutApiCall : null}
              buttonType={actionButton === false ? "button" : "submit"}
            />
            {/* </div> */}
          </div>
        </div>
      </React.Fragment>
    );
  };

  render() {
    if (this.state.loader) {
      return <AmealioLoader />;
    }
    return (
      <React.Fragment>
        <div className="container-fluid">
          <div className="row">
            <div className="left-side-panel">
              <LeftSideNavigation displayLink={1} />
            </div>
            <div className="super-admin-right-side-panel">
              <HomeReusableTopBarNavigation />
              <div className="col-6 pl-5 pr-5">
                <div className="super_admin_add_vendor mb-4">
                  <h5 className="main_header_text">
                    {this.props?.editDataAction ? "Edit" : "Add"} Vendor
                  </h5>
                  <h4 className="font_20_m">Step : 12</h4>
                  <h4 className="font_20_m c_red mt-2 mb-1">Other Features</h4>
                  <hr className="hr_line" />
                </div>
                <TopTextReusableComponent
                  headingText="Other Features"
                  headingParagraph="Enter the information about your features at your Business Establishment"
                />
                <Form noValidate onSubmit={this.onHandleSubmit}>
                  {this.renderDressCodeFields()}
                </Form>
              </div>
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

SuperAdminVendorOtherFeatures.propTypes = {
  auth: PropTypes.object.isRequired,
  errors: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  errors: state.errors.errors,
  onboardingData: state.superAdminOnboarding.restaurantDetails,
  editData: state?.adminAllVendorsInfo?.superAdminMerchantEditInfo,
  editDataAction:
    state?.adminAllVendorsInfo?.superAdminMerchantEditType?.editData,
  other_features: state.category.other_features,
});

export default connect(mapStateToProps, {
  clear_all_errors,
  superadmin_create_and_update_restaurant,
})(withRouter(SuperAdminVendorOtherFeatures));
